var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.93636 212.97759",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.434 -4.4328)",
    fill: "none",
    strokeWidth: 0.52918
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.34 65.24c0.60372-13.486 6.0851-26.702 15.204-36.657 9.1185-9.9546 21.804-16.572 35.186-18.353 8.7774-1.1686 17.836-0.29223 26.182 2.6658 8.3462 2.958 15.96 8.0047 21.835 14.63 5.8751 6.6251 9.9863 14.823 11.65 23.52 1.6636 8.6972 0.85851 17.871-2.4196 26.097-2.6818 6.7294-6.9201 12.706-11.135 18.597-29.152 40.75-59.1 80.931-89.821 120.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.34 65.24c2.1745-11.87-0.08983-24.5-6.2523-34.875-6.1625-10.375-16.17-18.406-27.634-22.176s-24.285-3.2449-35.402 1.4485-20.435 13.515-25.73 24.359c-4.7557 9.741-6.2607 20.904-5.1361 31.685s4.798 21.199 9.8984 30.764c10.201 19.13 25.818 34.689 40.52 50.622 20.192 21.883 39.044 45.001 56.417 69.182"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.aee37be5028b7f1ef9522dc19bdd45b1.svg";
export { ForwardRef as ReactComponent };